<div class="grid" id="references">
    <div class="col-12 col-md-12 col-lg-12 col-sm-12">
        <div *ngIf="hasDisplayableReferences()">
            <!-- <div class="section-header"><h3><b>References</b></h3></div> -->

            <div class="section-header">
                <div style="width: 100%; height: 27px; margin-bottom: 1em;" id="refHeader" #refHeader (window:resize)="onResize()"></div>
            </div>
            <div class="section-line"></div>

            <div style="margin: 0em 0em .5em 1em;" *ngFor="let ref of record['references']" class="ref-entry">
              <span *ngIf="ref.location; else noreflink">
                <span class="faa faa-external-link">&nbsp;</span>
                <a href={{ref.location}} target="blank">{{ getReferenceText(ref) }}</a>
              </span>
              <ng-template #noreflink>
                <span>{{ getReferenceText(ref) }}</span>
              </ng-template>
            </div>
        </div>
    </div>
</div>
